export function init() {
	Array.from(document.querySelectorAll('.js-tooltip')).forEach(e => tooltip(e));
}

function tooltip(element) {
	const visibleClass = 'is-visible';
	const tooltipElement = document.getElementById(element.getAttribute('aria-describedby'));

	if (!tooltipElement) {
		return;
	}

	document.body.append(tooltipElement);

	element.addEventListener('blur', hide, false);
	element.addEventListener('focus', show, false);

	element.addEventListener('mouseout', hide, false);
	element.addEventListener('mouseover', show, false);

	function show() {
		position();
		tooltipElement.classList.add(visibleClass);
	}

	function hide() {
		tooltipElement.removeAttribute('style');
		tooltipElement.classList.remove(visibleClass);
	}

	function position() {
		let positionClass = 'top';

		const rect = element.getBoundingClientRect();
		const tooltipRect = tooltipElement.getBoundingClientRect();
		const rectHorizontalCenter = rect.left + (rect.width / 2);

		const top = rect.top + document.documentElement.scrollTop - tooltipRect.height;
		const left = rectHorizontalCenter - (tooltipRect.width / 2);

		tooltipElement.classList.add(positionClass);
		tooltipElement.style.transform = `translate(${left}px, ${top - 20}px)`;
	}
}
